import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { getFuncAlbums } from '@src/containers/ProfileVenue/selectors/getFuncAlbums';
import { getRouteInfo } from '@src/containers/Session/selectors/getRouteInfo';

import ProfileAlbumsFunc from '..';

const ProfileAlbumsFuncCVenue = withRouter((props) => {
	const { history, location, ...rest } = props;
	const { albums } = useSelector(getFuncAlbums);
	const info = useSelector(getRouteInfo);
	const { query } = info;

	const initialIdx = useMemo(() => {
		if (!query?.album_id) return 0;
		const targetIdx = albums.findIndex((a) => {
			return query.album_id === `${a.id}`;
		});
		return Math.max(0, targetIdx);
	}, [query?.album_id, albums]);

	const [activeIdx, setActiveIdx] = useState(initialIdx);

	const targetAlbum = albums[activeIdx];

	useEffect(() => {
		const h = global.location.hash;
		if (!h || !h.match(new RegExp('^#album_'))) return;
		const id = h.split('_')[1];
		const targetIdx = Math.max(
			0,
			albums.findIndex((a) => {
				return id === `${a.id}`;
			}),
		);
		setActiveIdx(targetIdx);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleClickTab = useCallback((t) => {
		setActiveIdx(t.id);
	}, []);

	const handleClickImg = useCallback(
		(img, idx) => {
			const q = qs.parse(location.search, { ignoreQueryPrefix: true });
			history.push({
				search: qs.stringify(
					{ ...q, album_media: `${targetAlbum.id}_${idx}` },
					{ addQueryPrefix: true },
				),
			});
		},
		[history, location, targetAlbum],
	);

	const [tabsProps, targetImgs, desc] = useMemo(() => {
		const alb = albums[activeIdx];
		const imgs = (alb?.media || []).map((img) => {
			let i = img;
			if (typeof img === 'number') {
				i = { id: img, src: img };
			}
			return {
				img: { ...i, leadHeight: 200 },
				// href: `/album/${alb.id}/${i.id}${url ? `?from=${url}` : ''}`,
			};
		});

		const description = (albums[activeIdx]?.description || '').replace(
			/\n/g,
			'<br />',
		);

		return [
			{
				tabs: albums.map((a, i) => {
					return {
						id: i,
						label: a.title,
						isActive: i === activeIdx,
					};
				}),
				onClickTab: handleClickTab,
			},
			imgs,
			description,
		];
	}, [activeIdx, albums, handleClickTab]);

	return (
		<>
			<div
				style={{
					overflow: 'hidden',
					height: 1,
					width: 1,
					position: 'absolute',
					visibility: 'hidden',
				}}
			>
				{albums.map((a) => {
					return (
						<span
							key={a.id}
							id={`album_${a.id}`}
							style={{ position: 'absolute', top: '-90px' }}
						>
							{a.id}
						</span>
					);
				})}
			</div>
			<ProfileAlbumsFunc
				imgs={targetImgs}
				tabsProps={tabsProps}
				desc={desc}
				sliderKey={`slider${activeIdx}`}
				onClickTab={handleClickTab}
				onClickImg={handleClickImg}
				{...rest}
			/>
		</>
	);
});

export default ProfileAlbumsFuncCVenue;
